import React from 'react'
import { Dropdown, DropdownProps } from 'react-bootstrap'

import { KTIcon } from '../../_metronic/helpers'
import styles from './RowKebabMenu.module.css'

interface RowKebabMenuProps {
  /** Подпись кнопки (title/aria) — что это за меню, напр. «Действия по тикету». */
  title: string
  drop?: DropdownProps['drop']
  /** Контролируемое открытие — нужно, если пункт меню сам должен закрыть меню
   * после своего клика (см. ActivePaymentTicketRowMenu). Без него меню
   * неконтролируемое и закрывается штатно react-bootstrap. */
  show?: boolean
  onToggle?: (show: boolean) => void
  children: React.ReactNode
}

/**
 * Кнопка «⋮» действий строки списка — общий вид для всех построчных меню
 * (изначально ActivePaymentTicketRowMenu, CPAYMENT-1615; вынесено сюда при
 * повторном использовании в MerchantLedgerHistory, CPAYMENT-1739).
 *
 * Вызывающий компонент сам решает, рендерить ли меню вообще (пустая «⋮» без
 * доступных действий обманывает) и что положить в `children` (`Dropdown.Item`).
 *
 * **НЕ вешать stopPropagation на корень Dropdown.** react-bootstrap закрывает
 * открытое меню по клику снаружи через document — погасив всплытие, ломаем
 * закрытие ЧУЖИХ меню в соседних строках.
 */
export const RowKebabMenu: React.FC<RowKebabMenuProps> = ({
  title,
  drop = 'start',
  show,
  onToggle,
  children,
}) => (
  <Dropdown show={show} onToggle={onToggle} drop={drop}>
    {/*
      as='button' обязателен: иначе Dropdown.Toggle рендерит <Button>, у которого variant по
      умолчанию 'primary' — кнопка становится синей плашкой, и никакой className её не перебьёт.
      bsPrefix убирает класс dropdown-toggle вместе с его каретой.
    */}
    <Dropdown.Toggle
      as='button'
      type='button'
      bsPrefix='kebab-toggle'
      className={styles.kebab}
      title={title}
    >
      <KTIcon iconName='dots-vertical' className={styles.kebabIcon} />
    </Dropdown.Toggle>

    <Dropdown.Menu
      className='py-2'
      popperConfig={{
        modifiers: [{ name: 'offset', options: { offset: [0, 8] } }],
      }}
    >
      {children}
    </Dropdown.Menu>
  </Dropdown>
)

/**
 * Место под «⋮» в ячейке действий строки.
 *
 * Меню рендерится не всегда — вызывающий сам решает, есть ли у строки доступные действия, — а
 * ширина ячейки от этого меняться не должна: без слота остальные кнопки строки съезжают вбок
 * ровно на ширину «⋮», и в списке колонка действий перестаёт быть колонкой.
 */
export const RowKebabSlot: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className={styles.slot}>{children}</div>
)

export default RowKebabMenu
